import { generatePath } from 'react-router-dom';

export const REMOTE_CONTROL_PATHS = {
    v1: '/orgs/:orgId/devices/:deviceKeyId/remote',
    v2: '/v2/orgs/:orgId/devices/:deviceKeyId/remote',
};

export function remoteControlPath(
    orgId: number,
    deviceKeyId: string,
    interfaceVersion: keyof typeof REMOTE_CONTROL_PATHS = 'v1',
) {
    return generatePath(REMOTE_CONTROL_PATHS[interfaceVersion], {
        orgId: String(orgId),
        deviceKeyId: encodeURIComponent(deviceKeyId),
    });
}
